import { PartnerSearchFilterItem } from 'partner360/components/partnerSearchFilter'

import { compareByPartnerName } from './compareByPartnerName'

/**
 * Sorts partners by coverage descending (highest first). Partners without coverage
 * data are pushed to the end; ties (including missing-vs-missing) fall back to name.
 */
export const compareByCoverage = (
  left: PartnerSearchFilterItem,
  right: PartnerSearchFilterItem
) => {
  const leftCoverage = left.CoveragePercent
  const rightCoverage = right.CoveragePercent

  if (leftCoverage == null && rightCoverage == null) {
    return compareByPartnerName(left, right)
  }

  if (leftCoverage == null) {
    return 1
  }

  if (rightCoverage == null) {
    return -1
  }

  return rightCoverage - leftCoverage || compareByPartnerName(left, right)
}
